import React from 'react';
import cn from 'classnames';
import { ICalendarEvent, ICalendarEventPart, ICalendarRenderProps, ISidebarRouteState } from 'components';
import { StageState, UpdateState } from 'enums';
import { IHomeCalendarData } from '../Home';
import { CalendarLink } from './CalendarLink';
import { renderCounts } from './renderCounts';
import { renderBar } from './renderBar';
import { renderIcon } from './renderIcon';
import { getEventLabel } from './getEventLabel';
import { getEventTitle } from './getEventTitle';
import { ManufacturersService, UpdateTypesService } from 'services';

export function renderDayPanelEvent(
    { key, ...otherPropsFromCalendar }: ICalendarRenderProps,
    event: ICalendarEvent<IHomeCalendarData>,
    eventPart: ICalendarEventPart<IHomeCalendarData>,
    routeState: ISidebarRouteState,
    timezone: string,
) {
    const data = event.isGroupGap ? event.groupGapPrevEvent.data : event.data;
    const update = data.update;
    const stage = data.stage;
    const prevStage = update.rollout.stages?.[data.stageIndex - 1];
    // The stage is only ready for confirmation if the previous stage has already started.
    const canConfirmStage = update.state === UpdateState.Running
        && stage.state === StageState.Scheduled
        && stage.requiresConfirmation
        && !stage.isConfirmed
        && prevStage
        && (prevStage.state === StageState.Running || prevStage.state === StageState.Done);

    const updateFile = update.updateFile;
    const updateTypeId = updateFile?.updateTypeId
    const updateType = updateTypeId && UpdateTypesService.updateTypesMap[updateTypeId];
    const manufacturer = updateType && ManufacturersService.manufacturersMap[updateType.manufacturerId];
    const updateInfo = `${manufacturer?.name || ''} / ${updateType?.description || ''} / ${updateFile?.version || ''} - ${updateFile?.description || ''}`;

    return <CalendarLink
        canConfirmStage={canConfirmStage}
        isGroupGap={event.isGroupGap}
        key={key}
        propsFromCalendar={otherPropsFromCalendar}
        routeState={routeState}
        stage={stage}
        title={getEventTitle(event, timezone) }
        update={update}
    >
        <div className="calendarUpdateEvent_times">
            {renderBar(update, stage)}
            <div>{eventPart.formattedStartTime}</div>
            <div>{eventPart.formattedDuration}</div>
        </div>
        <div className="calendarUpdateEvent_dayPanelContent">
            <div className="calendarUpdateEvent_dayPanelLine1">
                <div className="calendarUpdateEvent_dayPanelLabel ellipsis">
                    {renderIcon(update, stage)}
                    <span className={cn({
                        'stage_canConfirmAnimated1': canConfirmStage,
                    })}>
                        <span>{getEventLabel(event)}</span>
                    </span>
                </div>
                {renderCounts(event)}
            </div>
            <div className="ellipsis">
                <span title={updateInfo}>
                    {updateInfo}
                </span>
            </div>
        </div>
    </CalendarLink>
}